import * as ActionTypes from './actionTypes'

export const setQuery = (query) => ({
  type: ActionTypes.SET_QUERY,
  query
})

export const clearSearch = () => ({
  type: ActionTypes.CLEAR_SEARCH
})

export const startSearch = () => ({
  type: ActionTypes.START_SEARCH
})

export const addResults = (mapId, results) => ({
  type: ActionTypes.ADD_RESULTS,
  results,
  mapId
})

export const endSearch = () => ({
  type: ActionTypes.END_SEARCH
})

export const showResults = (id) => ({
  type: ActionTypes.SHOW_RESULTS,
  id
})

export const hideResults = (id) => ({
  type: ActionTypes.HIDE_RESULTS,
  id
})